import React from "react";
import "./VirasatInputComponents.scss"



const VirasatInputComponents = ({ label, value, onChange, placeholder, required, error, errorText, disable, type = "text" }) => {


    return (
        <div className="VirasatInputComponents-VirasatDefault">
            <div className="input-label">
                {label}
                {required && <span className="input-req">* </span>}
            </div>
            <div className={`VirasatInputComponents-VirasatDefault-container ${error ? "error" : disable ? "disable" : ""}`}>
                <input
                    className="VirasatInputComponents-VirasatDefault-container-input"
                    value={value}
                    onChange={onChange}
                    type={type}
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default VirasatInputComponents
